import { redirect } from "react-router-dom";

export const requireAuth = () => {
  const token = sessionStorage.getItem("userToken");

  if (!token) {
    throw redirect("/");
  }

  return null;
};